import { useMutation, useQueryClient } from '@tanstack/react-query';
import { IProgressGPTReplyModel } from 'api/models';

import { createProgressGPTReply } from 'api/services';
import { toast } from 'react-toastify';

const useProgressGPTAddReplyForm = () => {
    const queryClient = useQueryClient();

    const addReplyMutation = useMutation(
        (payload: Pick<IProgressGPTReplyModel, 'message' | 'chatId' | 'metadata'>) =>
            createProgressGPTReply(payload.chatId, payload),
        {
            onSuccess: () => {
                queryClient.invalidateQueries({ queryKey: ['aiToken'] });
            },
            onError: (err: any) => {
                toast.error(err?.data?.message || 'Something went wrong.');
            },
        }
    );

    const submit = async (values: Pick<IProgressGPTReplyModel, 'message' | 'chatId' | 'metadata'>) => {
        const reply = await addReplyMutation.mutateAsync(values);

        return reply;
    };

    return {
        isLoading: addReplyMutation.isPending,
        submit,
    };
};

export default useProgressGPTAddReplyForm;
